import { useState, useEffect } from "react";

import { translate } from '../functions/translationHelper';

import lockimg from "../img/lock.svg";
import lockcheckimg from "../img/lock-check.svg";

function ContentCode(props) {
  const [input, setInput] = useState([]);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const {
    codeword,
    showPlaceholders,
    showNumbers,
    showAlphabet,
    customLetters = [],
    keyboardSize,
    headline,
    smalltext
  } = props.content;

  useEffect(() => {
    if (!props.active) {
      setInput([]);
      setSuccess(false);
      setError(false);
    }
  }, [props.active]);

  function checkInput() {
    if (input.join("") === codeword.join("")) {
      setSuccess(true);
      props.onCompletion();
    } else {
      setError(true);
      setTimeout(() => setError(false), 500);
    }
  }

  useEffect(() => {
    if (showPlaceholders && input.length === codeword.length) {
      checkInput();
    }
  }, [input, showPlaceholders, codeword]);

  // --- Keyboard rows ---
  const QWERTY_ROWS = [
    "QWERTYUIOP".split(""),
    "ASDFGHJKL".split(""),
    "ZXCVBNM".split(""),
  ];

  const isNumbersOnlyKeyboard = showNumbers && !showAlphabet && customLetters.length === 0;

  const buildKeyboardRows = () => {
    let rows = [];

    // If only numbers are shown (no alphabet/custom letters)
    if (isNumbersOnlyKeyboard) {
      rows = [
        ["1", "2", "3"],
        ["4", "5", "6"],
        ["7", "8", "9"],
        ["0"], // we’ll add backspace in JSX for the last row
      ];
      return rows;
    }

    // Normal behavior (numbers + letters)
    if (showNumbers) rows.push("1234567890".split(""));
    if (showAlphabet) rows = rows.concat(QWERTY_ROWS);

    if (customLetters.length > 0) {
      const existing = new Set(rows.flat());
      const extras = customLetters.filter((c) => !existing.has(c));
      if (extras.length) rows.push(extras);
    }

    return rows;
  };

  const keyboardRows = buildKeyboardRows();

  const getDisplayWord = () => {
    if (!showPlaceholders) return input.join("");
    return codeword.map((_, i) => (input[i] ? input[i] : "*")).join(" ");
  };

  return (
    <div className="page-content-code">
      <div className="page-content-code-wrapper">
        <div style={{ textAlign: "center" }}>
          <img className="lockimg" src={success ? lockcheckimg : lockimg} />
        </div>

        {headline && <div className="code-headline">{headline}</div>}

        <div
          className={`codeword ${error ? "codeworderror" : ""} ${
            success ? "codewordsuccess" : ""
          }`}
          style={{ fontSize: smalltext ? 22 : undefined }}
        >
          {getDisplayWord()}
        </div>

        <div className={`keyboardwrapper ${success ? "keyboardwrapper-hide" : ""}`}>
          <div
            className={`keyboard ${isNumbersOnlyKeyboard ? "keyboard-numbers-only" : ""}`}
            style={{ fontSize: keyboardSize ? keyboardSize : "" }}
          >
            {keyboardRows.map((row, rowIdx) => (
              <div key={`row-${rowIdx}`}>
                {row.map((char, i) => (
                  <span
                    key={`${char}-${rowIdx}-${i}`}
                    onClick={() =>
                      setInput((prev) => {
                        if (showPlaceholders) {
                          return prev.length < codeword.length
                            ? [...prev, char]
                            : prev;
                        } else {
                          return [...prev, char];
                        }
                      })
                    }
                  >
                    {char}
                  </span>
                ))}

                {/* Add Backspace to the last row */}
                {rowIdx === keyboardRows.length - 1 && (
                  <span
                    style={{ backgroundColor: "#ddd" }}
                    onClick={() => setInput((prev) => prev.slice(0, -1))}
                  >
                    ←
                  </span>
                )}
              </div>
            ))}
          </div>

          {!showPlaceholders && (
            <div
              style={{ opacity: input.length === 0 ? 0.5 : 1 }}
              className="button-primary"
              onClick={input.length > 0 ? checkInput : undefined}
            >
              {translate("check", props.language)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContentCode;
